import { SideImage } from '../../components/SideImage';
import { StickyFooter } from '../../components/StickyFooter';
import { SpaTreatmentFacilityBookingContent } from '../../composites/SpaTreatmentFacilityBookingContent';
import { SplitLayout } from '../../composites/SplitLayout';
import { HideOnMobile } from './SpaTreatmentFacilityBookingForm.styles';
import type { SpaTreatmentFacilityBookingFormProps } from './SpaTreatmentFacilityBookingForm.types';

export function SpaTreatmentFacilityBookingForm({
  imageUrl,
  imageAlt,
  onBack,
  stickyFooter,
  ...contentProps
}: SpaTreatmentFacilityBookingFormProps) {
  return (
    <SplitLayout
      left={
        <HideOnMobile>
          <SideImage src={imageUrl} alt={imageAlt} sticky onBack={onBack} />
        </HideOnMobile>
      }
      right={
        <>
          <SpaTreatmentFacilityBookingContent {...contentProps} />
          {stickyFooter && <StickyFooter {...stickyFooter} />}
        </>
      }
      contentGap="0px"
      contentMaxWidth="100%"
    />
  );
}
